import React from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import cataImg1 from "../../../assets/cataWhisky/img1.webp";
import cataImg2 from "../../../assets/cataWhisky/img2.webp";
import cataImg3 from "../../../assets/cataWhisky/img3.webp";
import "./CataWhiskyExperience.css";

const CataWhiskyExperience = () => {
  const phoneNumber = "5493515295096";
  const message = encodeURIComponent("Hola Whisky & Co, quiero reservar o consultar por la experiencia Cata Viva de Whisky.");
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;

  const images = [
    {
      src: cataImg1,
      alt: "Mesa de degustacion de whisky con copas"
    },
    {
      src: cataImg2,
      alt: "Seleccion de botellas para cata de whisky"
    },
    {
      src: cataImg3,
      alt: "Momento de degustacion guiada de whisky"
    }
  ];

  return (
    <section className="cata-whisky-section">
      <div className="cata-whisky-noise" aria-hidden="true" />
      <Container>
        <div className="cata-whisky-shell">
          <div className="cata-copy">
            <p className="cata-kicker">Experiencias Whisky & Co</p>
            <h2>Cata viva de whisky</h2>

            <div className="cata-highlights" aria-label="Aspectos principales de la experiencia">
              <span>4 o 5 etiquetas seleccionadas</span>
              <span>Maridajes pensados para cada perfil</span>
              <span>Encuentro guiado e interactivo</span>
            </div>

            <p>
              En nuestra vinoteca realizamos degustaciones de whisky pensadas para disfrutar, aprender y compartir. Cada encuentro incluye la degustación de 4 o 5 whiskies cuidadosamente seleccionados, acompañados por maridajes diseñados para resaltar las características de cada etiqueta.
            </p>

            <p>
              Más que una cata tradicional, proponemos una experiencia dinámica e interactiva, donde la conversación, el descubrimiento y el disfrute son los protagonistas. Una forma diferente de acercarse al mundo del whisky, tanto para quienes recién comienzan como para quienes ya son aficionados.
            </p>

            <a
              href={whatsappURL}
              target="_blank"
              rel="noopener noreferrer"
              className="cata-whatsapp-btn"
            >
              Consultar por cata
            </a>
          </div>

          <div className="cata-gallery" aria-label="Imagenes de catas de whisky">
            <Swiper
              modules={[Autoplay, Pagination]}
              slidesPerView={1}
              loop={true}
              speed={700}
              autoplay={{ delay: 3600, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              className="cata-swiper"
            >
              {images.map((image) => (
                <SwiperSlide key={image.src}>
                  <figure className="cata-image-card">
                    <img src={image.src} alt={image.alt} loading="lazy" />
                  </figure>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CataWhiskyExperience;
